module.exports = "//import './modernizr.js'; // 'npm run modernizr' to create this file\r\n//import '../node_modules/ika.jvectormap/jquery-jvectormap-1.2.2.min.js';\r\n//import '../node_modules/ika.jvectormap/jquery-jvectormap-world-mill-en.js';\r\n//import '../node_modules/ika.jvectormap/jquery-jvectormap-us-mill-en.js';\r\n//import '../node_modules/loaders.css/loaders.css.js';\r\n//# sourceMappingURL=C:/Users/TEJADA/Desktop/PROYECTOS MGS/imm/V3/front/src/vendor.js.map"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@ngtools/webpack/src!./src/vendor.ts
// module id = 1267
// module chunks = 5